import {Injectable, signal} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private static readonly themeStorageKey = 'theme';
  private static readonly darkTheme = 'dark';
  private static readonly lightTheme = 'light';
  private static readonly premiumThemeClass = 'premium';

  public isDarkMode = signal<boolean>(false);

  constructor() {
    this.setTheme(localStorage.getItem(ThemeService.themeStorageKey) === ThemeService.darkTheme);
  }

  public toggleTheme(): void {
    this.setTheme(!this.isDarkMode());
  }

  public applyPremiumTheme(): void {
    document.documentElement.classList.add(ThemeService.premiumThemeClass);
  }

  public clearPremiumTheme(): void {
    document.documentElement.classList.remove(ThemeService.premiumThemeClass);
  }

  private setTheme(isDark: boolean): void {
    this.isDarkMode.set(isDark);
    document.documentElement.classList.toggle(ThemeService.darkTheme, isDark);
    localStorage.setItem(ThemeService.themeStorageKey, isDark ? ThemeService.darkTheme : ThemeService.lightTheme);
  }
}
